let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("13eRe")).then(() => parcelRequire('dEMxV'));